module.exports = __webpack_public_path__ + "static/media/Rasp_Medium.b33ee0f2.webp";